import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
/*import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";*/
import './sass/master.scss';
import routes from './routes';

import {Provider} from 'react-redux';
import Store from './store.js';
import history from './libs/history';
import Aqp from './libs/mk-react-aqp';
import {BreakpointProvider} from "./libs/breakpoint";


Aqp.init(history);

const queries = {
    xs: '(max-width: 320px)',
    sm: '(max-width: 720px)',
    md: '(max-width: 1024px)',
    lg: '(max-width: 1200px)',
    or: '(orientation: portrait)'
}

/*if (process.env.REACT_APP_SENTRY_DSN){
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
        autoSessionTracking:true,
        beforeSend(event, hint) {
            if (event.exception) {
                let appendedOptions = event.user ? {
                    labelName: "Pseudo",
                    user: {
                        name: event.user.username,
                        email: event.user.email
                    }
                } : {};
                Sentry.showReportDialog({eventId: event.event_id, lang: "fr", ...appendedOptions});
            }
            return event;
        },
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
            })
        ],
        tracesSampleRate: 0.02,
        ignoreErrors: ['ResizeObserver loop limit exceeded']
    });
}*/

ReactDOM.render(
    <BreakpointProvider queries={queries}>
        <Provider store={Store}>
            {routes}
        </Provider>
    </BreakpointProvider>,
    document.getElementById('root')
);